module.exports = __webpack_public_path__ + "img/1488423236.4330a6e6.jpg";